import React from 'react';
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";


const FormTooltip = ({message}) => {
    return <Tooltip title={message} placement="top" arrow sx={{mb: 0.5}}>
        <Icon color='info'>info</Icon>
    </Tooltip>
}

export const FieldWithTooltip = ({children, message}) => {
    return <div style={{display: 'flex', alignItems: 'end', columnGap: 12}}>
        {children}
        <FormTooltip message={message}/>
    </div>
}


export default FormTooltip;